import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isDefaultIntegration: false,
  isHighlightActive: false,
  shouldMountIntegrationByDefault: true,
  sessionApiHost: ''
};

export const pageConfigSlice = createSlice({
  name: "pageConfig",
  initialState,
  reducers: {
    toggleDefaultIntegration: (state) => {
      state.isDefaultIntegration = !state.isDefaultIntegration;
    },
    toggleHighlight: (state) => {
      state.isHighlightActive = !state.isHighlightActive;
    },
    toggleShouldMountIntegrationByDefault: (state) => {
      state.shouldMountIntegrationByDefault =
        !state.shouldMountIntegrationByDefault;
    },
    setSessionApiHost: (state, action) => {
      state.sessionApiHost = action.payload;
    }
  }
});

export const {
  toggleDefaultIntegration,
  toggleHighlight,
  toggleShouldMountIntegrationByDefault,
  setSessionApiHost
} = pageConfigSlice.actions;

export const getPageConfig = (state) => state.pageConfig;

export default pageConfigSlice.reducer;
